import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import type { MvaDashboard } from '@/types/mva'

export function useFetchMvaDashboard(id_apuracao?: string) {
  return useQuery({
    queryKey: ['mva-dashboard', id_apuracao],
    queryFn: async () => {
      if (!id_apuracao) throw new Error('ID da apuração não fornecido')

      const response = await api.get<{ data: MvaDashboard }>(`/mva/${id_apuracao}/dashboard`)
      return response.data.data
    },
    enabled: Boolean(id_apuracao)
  })
}
